import React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Button, Stack } from '@mui/material';

interface AccordionSectionProps {
  title: string;
  buttonLabel?: string;
  onButtonClick?: () => void;
  disabled?: boolean;
  children?: React.ReactNode;
  isOpen?: boolean;
}

const AccordionSection = ({
  title,
  buttonLabel,
  onButtonClick,
  disabled,
  children,
  isOpen,
}: AccordionSectionProps) => (
  <Accordion>
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
      <Typography>{title}</Typography>
    </AccordionSummary>
    <AccordionDetails>
      <Stack spacing={2}>
        {children}
        {buttonLabel && onButtonClick && (
          <Button
            color="secondary"
            variant="outlined"
            fullWidth
            onClick={onButtonClick}
            disabled={disabled || isOpen}
          >
            {buttonLabel}
          </Button>
        )}
      </Stack>
    </AccordionDetails>
  </Accordion>
);

export default AccordionSection;
